import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

export function getTranslation(
  translate: TranslateService | any,
  key: string | string[],
  params?: any,
): Observable<any> {
  const t: any = translate as any;

  if (t && typeof t.get === 'function') {
    return t.get(key, params);
  }

  // Fallback to instant if get is not available (common in unit test mocks)
  if (t && typeof t.instant === 'function') {
    if (Array.isArray(key)) {
      const res: any = {};
      key.forEach((k) => (res[k] = t.instant(k, params)));
      return of(res);
    }
    return of(t.instant(key, params));
  }

  // As a last resort, return the key(s) directly
  if (Array.isArray(key)) {
    const res: any = {};
    key.forEach((k) => (res[k] = k));
    return of(res);
  }
  return of(key);
}
